// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"tP-z","carouselContainer":"uP-z"};